import { Model, useEffectAsync } from "@alphascriptsolutions/client-core";
import { message } from "antd";
import Renderer from "@/components/Renderer";
import { setupButtonGroup } from "@/utils/imageSelectButton";
import { useReducer } from "react";
import { useAlphaAgentStore } from "@/state/alphaAgentStore";

export default function CustomFeatures() {
  const { customFeatureModel, setCustomFeatureModel } = useAlphaAgentStore();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffectAsync(async () => {
    const path = "/assets/alphaAgent/CustomFeatures.yml";

    try {
      let loadedModel = await Model.fromFile(path);
      if (!loadedModel.isValid()) {
        throw new Error(`Problem loading model from ${path}: ${loadedModel.getError()}`);
      }

      const loadedModelWithEvent = addEventsOnModel(loadedModel);
      setCustomFeatureModel(loadedModelWithEvent);
    } catch (err) {
      message.error(err.message);
    }
  }, []);

  function addEventsOnModel(model: Model): Model {
    // For Indexation
    const imageButtonNames = ["percentageChangeChart", "actualTradedValueChart"];
    setupButtonGroup(imageButtonNames, model, forceUpdate, true);

    // For Custom Build Value Line
    const imageButtonConstantValueLineNames = ["addCustomBuiltIndices", "noCustomBuiltIndices"];
    setupButtonGroup(imageButtonConstantValueLineNames, model, forceUpdate, true);

    // For Static Line
    const imageButtonStaticLineNames = ["addConstantLineSelection", "noConstantLineSelection"];
    setupButtonGroup(imageButtonStaticLineNames, model, forceUpdate, true);

    // Question 1: Trading Volume
    const secondaryVerticalAxisButtonNames = [
      "addsecondaryVerticalAxisColumnChart",
      "nosecondaryVerticalAxisColumnChart",
    ];
    setupButtonGroup(secondaryVerticalAxisButtonNames, model, forceUpdate, true);

    // Question 2: Summary Table
    const summaryTableImageNames = ["addsummaryTable", "nosummaryTable"];
    setupButtonGroup(summaryTableImageNames, model, forceUpdate, true);

    // Question 3: Small Line Chart
    const smallLineChartImageNames = ["addSmallLineChart", "nosmallLineChart"];
    setupButtonGroup(smallLineChartImageNames, model, forceUpdate, true);

    // Question 4: Call Out Boxes
    const callOutBoxesImageNames = ["addCallOutBoxes", "noCallOutBoxes"];
    setupButtonGroup(callOutBoxesImageNames, model, forceUpdate, true);

    // Question 5: Background Shading
    const backgroundShadingImageNames = ["addBackgroundShading", "noBackgroundShading"];
    setupButtonGroup(backgroundShadingImageNames, model, forceUpdate, true);

    // Question 6: Vertical Line
    const verticalLineImageNames = ["addVerticalLine", "noVerticalLine"];
    setupButtonGroup(verticalLineImageNames, model, forceUpdate, true);
    return model;
  }

  return (
    <div className="mt-6 p-4">
      <Renderer model={customFeatureModel} />
    </div>
  );
}
